export default __webpack_public_path__ + "static/media/cityscape.b95783f9.jpg";